import { ILogger, TContext } from '@honeybook/core';
import {
    ILoggerServiceProps,
    LoggerService
} from '~/services/logger/logger.service';

export class LoggerAdapter implements ILogger {
    private loggerService: LoggerService;

    constructor(props: ILoggerServiceProps) {
        // Create a LoggerService with the provided props
        this.loggerService = new LoggerService(props);
    }

    debug(message: string, context?: TContext): void {
        this.loggerService.logDebug(message, context);
    }

    info(message: string, context?: TContext): void {
        this.loggerService.logInfo(message, context);
    }

    warn(message: string, context?: TContext): void {
        this.loggerService.logWarn(message, context);
    }

    error(error: string | Error, context?: TContext): void {
        const message = typeof error === 'string' ? error : error.message;
        this.loggerService.logError(message, context);
    }
}

/**
 * Factory function to create a logger that implements ILogger
 */
export function createLogger(props: ILoggerServiceProps = {}): ILogger {
    return new LoggerAdapter(props);
}
